module.exports = __webpack_public_path__ + "static/media/biteship-monitor-icon.0e26d527.png";